import React from "react";

import IconEmail from "./icon-email.svg";
import { Button } from "./styles";

export type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const FallbackSignUpButton: React.FunctionComponent<Props> = ({ ...props }) => (
  <Button {...props}>
    <IconEmail />
    SIGN UP
  </Button>
);

FallbackSignUpButton.displayName = "FallbackSignUpButton";
